import React, { useEffect, useState } from "react";
import { Field, useFormik, Form, Formik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import SVG from "react-inlinesvg";
import { useAlert } from "react-alert";
import { Input } from "../../../../_metronic/_partials/controls";
import { baseUrl } from "../../../../services/config";
import CustomSelect from "../../Student/Form/CustomSelect";
import { Table, Modal, Spinner, Alert } from "react-bootstrap";
import { values } from "lodash-es";
import MaskedInput from "react-text-mask";
import Select from "react-select";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import EditDefinedFee from "../../Student/updateDefinedFee";
import { Toaster, toast } from "react-hot-toast";
import { MdUpdate } from "react-icons/md";
import { PremissionChecker } from "../../../../services/PremissionChecker";
import { Empty } from "antd";
const cnicNumberMask = [
  /[1-9]/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
];

const EditStudent = ({
  studentDetail,
  show,
  reload,
  onUpdateStudent,
  reloader,
  defConce,
  defaulthol,
  defaultVel,
  defaultSchool,
}) => {
  const STUD_STATUS = [
    {
      id: 1,
      title: "Registered Only",
    },
    {
      id: 2,
      title: "Admission Only",
    },
    {
      id: 3,
      title: "Applied For Admission",
    },
    {
      id: 4,
      title: "Struck Off",
    },
    {
      id: 5,
      title: "Passout",
    },
    {
      id: 6,
      title: "Leaving",
    },
    {
      id: 7,
      title: "Migrate",
    },
  ];

  const [selectedEmpId, setselectedEmpId] = useState(studentDetail.employee_id);
  const alert = useAlert();
  const authtoken = localStorage.getItem("userToken");
  const user = useSelector((state) => state.user.user);
  const [hostelIDs, setHostelIDs] = useState([]);
  const [vehicleIDs, setVehicleIDs] = useState([]);
  const [concession, setconcession] = useState([]);
  const [paymentType, setPaymentType] = useState([]);
  const [previousSchoolData, setPreviousSchoolData] = useState([]);
  const [studentStatusData, setStudentStatusData] = useState([]);
  const [loading, setloading] = useState(false);
  const [campuses, setallcampuses] = useState(user.campuses || []);
  const [studentStatus, setstudentStatus] = useState(studentDetail.status);
  const [defaultgender, setdefaultgender] = useState(studentDetail.gender);
  const [inServiceEmpList, setinServiceEmpList] = useState([]);
  const [editablefee, seteditablefee] = useState({});
  const [editmodal, seteditmodal] = useState(false);
  const [allDefinedFees, setallDefinedFees] = useState([]);
  const [deleteloading, setdeleteloading] = useState(false);
  const [deleteModal, setdeleteModal] = useState(false);
  const [anyvehicle, setanyvehicle] = useState("");
  const [concessionSlab, setConcessionSlab] = useState(
    studentDetail?.concession
  );
  const [anyPaymentType, setAnyPaymentType] = useState(
    studentDetail.payment_type_id
  );
  const [prevSchool, setPrevSchool] = useState(
    studentDetail.previous_school_id
  );
  const [deleteablefee, setdeleteablefee] = useState({});
  const [errorsLis, setErrorsLis] = useState("");
  const [anyconcesstion, setanyconcesstion] = useState("");
  const [anyhostel, setanyhostel] = useState(studentDetail.hostel_id);

  const [errorcreate, seterrorcreate] = useState("Please fill all fields");
  const [isallfields, setisallfields] = useState(false);
  const [allsessions, setallsessions] = useState([]);
  ////consession part started
  const [allconcessions, setallconcessions] = useState([]);
  const [allowedconcession, setallowedconcession] = useState(0);
  const [selectedConcType, setselectedConcType] = useState("Amount");
  const [applyconcessionbtn, setapplyconcessionbtn] = useState(true);
  const [empEnable, setempEnable] = useState(false);
  const [onChangeAmount, setonChangeAmount] = useState("");
  const [onChangeNetAmount, setonChangeNetAmount] = useState("");
  const [concessionamount, setconcessionamount] = useState(0);
  const [feetypes, setfeetypes] = useState([]);
  const [amount, setamount] = useState("");
  const [selectedfeetype, setselectedfeetype] = useState("");
  const [isallowedconcesstion, setisallowedconcesstion] = useState(true);
  const [remarks, setremarks] = useState("");
  const [showStuckDate, setShowStuckDate] = useState(
    studentDetail.status == 4 ||
      studentDetail.status == 5 ||
      studentDetail.status == 6 ||
      studentDetail.status == 7
      ? true
      : false
  );

  const [campusCourseData, setCampusCourseData] = useState([]);
  const [courseClassData, setCourseClassData] = useState([]);
  const [classSectionData, setClassSectionData] = useState([]);

  const [campusId, setCampusId] = useState(studentDetail.campus_id);
  const [courseId, setCourseId] = useState(studentDetail.course_id);
  const [classId, setClassId] = useState(studentDetail.student_class_id);

  useEffect(() => {
    if (studentDetail.hostel_id == "0") {
      studentDetail.hostel_id = "";
    }
    getAllSessions();
    getStudentStatus();
    getCampusCourses(studentDetail.campus_id);
    getCourseClasses(studentDetail.course_id);
    getSectionsList(studentDetail.student_class_id);

    getVehicleID();
    getHostelID();
    getconcession();
    getPaymentType();
    getPreviousSchool();
    getEmpList();
    getDefinedFees();
    getConcessionTypes();
    setanyconcesstion(defConce?.id || "");
  }, []);

  // useEffect(() => {

  // }, [])

  const getEmpList = () => {
    fetch(`${baseUrl}/employees_all_campus`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify({
        job_status_id: "1",
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          setinServiceEmpList(data.payload);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllSessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallsessions(data.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getStudentStatus = () => {
    fetch(`${baseUrl}/student-status`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setStudentStatusData(data.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onCampusChange = (id) => {
    setCampusId(id);
    getCampusCourses(id);
  };

  const getCampusCourses = (id) => {
    if (id == "") {
      return alert.error("Please Select Campus");
    }
    fetch(`${baseUrl}/campus-all-courses/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCampusCourseData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onCourseChange = (id) => {
    setCourseId(id);
    getCourseClasses(id);
  };

  const getCourseClasses = (id) => {
    if (id == "") {
      return alert.error("Please Select Course");
    }
    fetch(`${baseUrl}/course-all-classes/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseClassData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onClassChange = (id) => {
    setClassId(id);
    getSectionsList(id);
  };

  const getSectionsList = (id) => {
    fetch(
      `${baseUrl}/class-section/${campusId}/${courseId}/${id ? id : classId}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      }
    )
      .then((res) => {
        res.json().then((data) => {
          setClassSectionData(data.payload);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const createEroors = (errors, touched, isSubmitting, values) => {
    setisallfields(false);

    if (errors.name && touched.name) {
      seterrorcreate(errors.name);
      setisallfields(true);
      return;
    }

    if (errors.father_name && touched.father_name) {
      seterrorcreate(errors.father_name);
      setisallfields(true);
      return;
    }
    if (errors.year_id && touched.year_id) {
      seterrorcreate(errors.year_id);
      setisallfields(true);
      return;
    }

    if (errors.religion && touched.religion) {
      seterrorcreate(errors.religion);
      setisallfields(true);
      return;
    }

    if (errors.dob && touched.dob) {
      seterrorcreate(errors.dob);
      setisallfields(true);
      return;
    }

    if (errors.gender && touched.gender) {
      seterrorcreate(errors.gender);
      setisallfields(true);
      return;
    }

    if (errors.campus_id && touched.campus_id) {
      seterrorcreate(errors.campus_id);
      setisallfields(true);
      return;
    }

    if (errors.course_id && touched.course_id) {
      seterrorcreate(errors.course_id);
      setisallfields(true);
      return;
    }

    if (errors.class_id && touched.class_id) {
      seterrorcreate(errors.class_id);
      setisallfields(true);
      return;
    }

    if (errors.section_id && touched.section_id) {
      seterrorcreate(errors.section_id);
      setisallfields(true);
      return;
    }

    // if (!errors.campus_id && touched.campus_id) {
    //   onchangeCampus(values);
    // }

    // if (!errors.educationType && touched.educationType) {
    //   getSectionsListOnTypeChange(
    //     values.campus_id,
    //     values.educationType,
    //     values.class_id
    //   );
    // }

    if (errors.concesstion_remarks && touched.concesstion_remarks) {
      seterrorcreate(errors.concesstion_remarks);
      setisallfields(true);
      return;
    }
    // if (errors.educationType && touched.educationType) {
    //   seterrorcreate(errors.educationType);
    //   setisallfields(true);
    //   return;
    // }
    // if (!errors.class_id && touched.class_id) {
    //   //  getclasssections(values.campus_id, values.class_id)
    //   onchangeClass(values);
    // }

    if (errors.address && touched.address) {
      seterrorcreate(errors.address);
      setisallfields(true);
      return;
    }
    if (errors.leaving_date && touched.leaving_date) {
      seterrorcreate(errors.leaving_date);
      setisallfields(true);
      return;
    }
    // if (errors.shift && touched.shift) {
    //     seterrorcreate(errors.shift)
    //     setisallfields(true)
    //     return;
    // }

    if (errors.remarks && touched.remarks) {
      seterrorcreate(errors.remarks);
      setisallfields(true);
      return;
    }

    if (errors.class_left && touched.class_left) {
      seterrorcreate(errors.class_left);
      setisallfields(true);
      return;
    }

    // if (errors.cnic_no && touched.cnic_no) {
    //   seterrorcreate(errors.cnic_no);
    //   setisallfields(true);
    //   return;
    // }
    if (errors.father_cnic && touched.father_cnic) {
      seterrorcreate(errors.father_cnic);
      setisallfields(true);
      return;
    }
    if (errors.mobile_no && touched.mobile_no) {
      seterrorcreate(errors.mobile_no);
      setisallfields(true);
      return;
    }
    // if (values.mobile_no == '') {
    //     values.mobile_no = '+92'
    // }

    if (errors.phone && touched.phone) {
      seterrorcreate(errors.phone);
      setisallfields(true);
      return;
    }
  };

  const updateStudentLiableFees = async () => {
    let data = {
      student_id: studentDetail.id,
    };

    await fetch(`${baseUrl}/update-liable-fee`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        // setReceiveBtn(false);

        if (data.metadata) {
          if (data.metadata.success) {
            alert.show(data.payload);
            getDefinedFees();
          }
        }
      })
      .catch((err) => {
        alert.error("Error Occurred");
        console.log(err);
      });
  };

  const StudentRegistrationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),

    father_name: Yup.string().required("Father name is required"),

    dob: Yup.string().notRequired("Date Of Birth required field"),
    stuck_date: showStuckDate
      ? Yup.string()
          .nullable()
          .required("Stuck Of Date is Required")
      : Yup.string()
          .nullable()
          .notRequired("Stuck Of Date is Required"),

    religion: Yup.string()
      .notRequired("Religion is required field")
      .nullable(),
    gender: Yup.string().required("Gender Is Required"),
    // concession_id: Yup.number()
    //   .notRequired('field must be a number'),

    // hostel_id: Yup.number()
    //   .notRequired('field must be a number'),

    // mobile_no: Yup.string()
    //     .required('Mobile Number required field'),

    mobile_no: Yup.string()
      .required("Mobile Number required field")
      .matches(
        /^(3)([0-9]{9})$/,
        "Mobile Number Must start with 3 and must have 13 digits"
      ),

    address: Yup.string().required("Address Is Required"),

    // remarks: Yup.string().notRequired('Remarks required field'),

    // previous_school: Yup.string().notRequired('last School is not required field'),

    // class_left: Yup.string().notRequired('Class Left required field'),

    // leaving_date: Yup.string().notRequired('Leaving Date not required field'),

    // vehicle_id: Yup.number()
    //   .notRequired('required field'),

    shift: Yup.string()
      .notRequired("Shift is not required!")
      .nullable(),

    cnic_no: Yup.string()
      .notRequired()
      .nullable(),
    // .matches(/^[0-9]{5}-[0-9]{7}-[0-9]$/, 'CNIC No must follow the XXXXX-XXXXXXX-X format!'),

    // // medium:Yup.string()
    // // .ensure()
    // // .required(" required!"),

    year_id: Yup.string().required("Session is required"),
    campus_id: Yup.string().required("Campus Is required"),
    course_id: Yup.string().required("Course Is required"),
    class_id: Yup.string().required("Class Is Required"),
    section_id: Yup.string().required("Section Is required"),

    payment_type_id: Yup.string().required("Payment Type Is required"),
    father_cnic: Yup.string().notRequired("Father Cnic required field"),
    // .matches(/^[0-9]{5}-[0-9]{7}-[0-9]$/, 'CNIC No must follow the XXXXX-XXXXXXX-X format!'),

    phone: Yup.string()
      .notRequired("phone required field")
      .matches(
        /^(?!92)\d+/,
        "Please enter a valid landline number without the country code."
      )
      .nullable(),
    concesstion_remarks:
      anyconcesstion != ""
        ? Yup.string().required("Concession Remarks is required")
        : Yup.string()
            .notRequired()
            .nullable(),
    // .matches(/^(3)([0-9]{9})$/, 'landline Number  Must start with 3 and must have 13 digits'),

    // applied_for: Yup.string()
    //   .required('required field'),
  });
  // const StudentRegistrationSchema = Yup.object().shape({

  //     name: Yup.string()
  //         .required('name is required'),

  //     father_name: Yup.string()
  //         .required('father name is required'),

  //     dob: Yup.string()
  //         .required('required field'),

  //     religion: Yup.string()
  //         .required('required field'),

  //     // concession_id: Yup.number()
  //     //     .notRequired('field must be a number'),

  //     // hostel_id: Yup.number()
  //     //     .notRequired('field must be a number'),

  //     mobile_no: Yup.string()
  //         .required('required field'),

  //     address: Yup.string()
  //         .required('required field'),

  //     remarks: Yup.string()
  //         .required('required field'),

  //     previous_school: Yup.string()
  //         .required('required field'),

  //     class_left: Yup.string()
  //         .required('required field'),

  //     leaving_date: Yup.string()
  //         .required('required field'),

  //     vehicle_id: Yup.number()
  //         .notRequired('required field'),

  //     shift: Yup.string()
  //         // .ensure()
  //         .required("Shift is required!"),

  //     cnic_no: Yup.string()
  //         .required('required field'),

  //     student_class_id: Yup.number()
  //         .required('field must be a number'),
  //     student_section_id: Yup.number()
  //         .required('field must be a number'),

  //     //  medium:Yup.string()
  //     //  .ensure()
  //     //  .required(" required!"),

  //     course_id: Yup.number()
  //         .required('field must be a number'),

  //     father_cnic: Yup.string()
  //         .required('required field'),

  //     phone: Yup.string()
  //         .required('required field'),

  //     //  applied_for: Yup.string()
  //     //    .required('required field'),

  // });
  const getHostelID = async () => {
    await fetch(`${baseUrl}/hostel`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setHostelIDs(data.payload);
      })
      .catch((err) => {
        console.log("hostel", err);
      });
  };
  const getVehicleID = async () => {
    await fetch(`${baseUrl}/vehicle`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setVehicleIDs(data.payload);
      })
      .catch((err) => {
        console.log("vehicle", err);
      });
  };

  const getconcession = async () => {
    await fetch(`${baseUrl}/concession`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setconcession(data.payload);
      })
      .catch((err) => {
        console.log("vehicle", err);
      });
  };

  const getPaymentType = async () => {
    await fetch(`${baseUrl}/payment-types`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setPaymentType(data.payload);
      })
      .catch((err) => {
        console.log("paymentType", err);
      });
  };

  const getPreviousSchool = async () => {
    await fetch(`${baseUrl}/previous-school`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setPreviousSchoolData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const numberChange = (strn) => {
    if (strn) {
      var resultString = strn.replace("92", "");

      return resultString;
    } else {
      return "";
    }
  };

  const initialValues = {
    isformsubmitted: false,
    name: studentDetail.name,
    father_name: studentDetail.father_name,
    year_id: studentDetail.year_setting_id,
    campus_id: studentDetail.campus_id,
    course_id: studentDetail.course_id,
    class_id: studentDetail.student_class_id,
    section_id: studentDetail.global_section_id,
    dob: studentDetail.dob,
    religion: studentDetail.religion,
    gender: studentDetail.gender,
    concession_id: studentDetail.concession_id,
    hostel_id: studentDetail.hostel_id == 0 ? "" : studentDetail.hostel_id,
    mobile_no: numberChange(studentDetail.mobile_no),
    address: studentDetail.address,
    remarks: studentDetail.remarks == null ? "" : studentDetail.remarks,
    previous_school_id: studentDetail.previous_school_id,
    class_left:
      studentDetail.class_left == null ? "" : studentDetail.class_left,
    leaving_date:
      studentDetail.leaving_date == null ? "" : studentDetail.leaving_date,
    joining_date:
      studentDetail.joining_date == null ? "" : studentDetail.joining_date,
    vehicle_id: studentDetail.vehicle_id,
    shift: studentDetail.shift,
    cnic_no: studentDetail.cnic_no,
    father_cnic: studentDetail.father_cnic,
    phone:
      studentDetail.phone == "92null" ? "" : numberChange(studentDetail.phone),
    stuck_date: studentDetail.struck_off_date,
    concesstion_remarks:
      studentDetail?.concession_remarks == null
        ? ""
        : studentDetail?.concession_remarks,
    concession: studentDetail?.concession == 0 ? "" : studentDetail?.concession,
    payment_type_id: studentDetail?.payment_type_id,
  };

  if (
    studentDetail.phone?.charAt(0) == "+" &&
    studentDetail.phone?.charAt(1) == "9" &&
    studentDetail.phone?.charAt(2) == "2"
  ) {
    initialValues.phone = studentDetail.phone.substring(3);
  }
  if (
    studentDetail.mobile_no?.charAt(0) == "+" &&
    studentDetail.mobile_no?.charAt(1) == "9" &&
    studentDetail.mobile_no?.charAt(2) == "2"
  ) {
    initialValues.mobile_no = studentDetail.mobile_no.substring(3);
  }

  const AddStudentHandler = async (values) => {
    setisallfields(false);
    const fdata = {
      name: values.name,
      father_name: values.father_name,
      year_id: values.year_id,
      campus_id: values.campus_id,
      course_id: values.course_id,
      student_class_id: values.class_id,
      global_section_id: values.section_id,
      dob: values.dob,
      gender: values.gender,
      concession_id: anyconcesstion,
      concession: values.concession,
      hostel_id: anyhostel == "0" ? null : anyhostel,
      vehicle_id: anyvehicle != "" ? anyvehicle : studentDetail.vehicle_id,
      employee_id: selectedEmpId,
      father_cnic: values.father_cnic,
      cnic_no: values.cnic_no,
      religion: values.religion,
      // education_type: values.educationType,
      mobile_no: "92" + values.mobile_no,
      address: values.address,
      remarks: values.remarks,
      previous_school_id:
        prevSchool != null ? prevSchool : studentDetail.previous_school_id,
      class_left: values.class_left,
      leaving_date: values.leaving_date == null ? "" : values.leaving_date,
      shift: values.shift,
      // medium: values.medium,
      phone: "92" + values.phone,
      joining_date: values.joining_date,
      status: studentStatus,
      struck_off_date: showStuckDate ? values.stuck_date : "",
      concession_remarks:
        anyconcesstion != "" || anyconcesstion != null
          ? values.concesstion_remarks
          : null,
      concession:
        anyconcesstion != "" || anyconcesstion != null
          ? values.concession
          : null,
      payment_type_id:
        anyPaymentType != null ? anyPaymentType : studentDetail.payment_type_id,
      // admission_id: 123,
      // applied_for: values.applied_for,

      // qualification: values.qualification,
    };
    if (fdata.hostel_id == "0") {
      fdata["hostel_id"] = "";
    }

    fetch(`${baseUrl}/student/${studentDetail.id}?_method=PUT`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(fdata),
    })
      .then((res) => {
        res.json().then((data) => {
          if (data.metadata.success) {
            setloading(false);
            onUpdateStudent("", data.payload.campus_id);
            toast.success("Updated Successfully");

            reloader(studentDetail.global_section_id);
          } else {
            if (toString.call(data.metadata.message) == "[object Object]") {
              Object.values(data.metadata.message).map((msg) => {
                toast.error(msg);
              });
            } else {
              toast.error(data.metadata.message);
            }

            setloading(false);
          }
        });
      })
      .catch((err) => {
        setloading(false);
        toast.success(err);

        console.log(err);
      });
  };

  if (studentDetail.gender == "Male") {
    let data = {
      value: "Male",
      label: "Male",
    };
  }

  let array = ["Male", "Female", "Other"];

  const Genderoptions = [
    // { value: 'Male', label: 'Male' },
    // { value: 'Female', label: 'Female' },
    // { value: 'Other', label: 'Other' },
  ];
  array.map((item, index) => {
    let checkselect = false;
    if (defaultgender == item) {
      checkselect = true;
    }

    Genderoptions[index] = { value: item, label: item, selected: checkselect };
  });

  const concessionOptions = concession.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const defaultConcession = {
    value: defConce?.id || "",
    label: defConce?.name || "Select",
  };

  // const concessionoption = [{ value: "", label: "Select" }];
  // concession.map((item, index) => {
  //   concessionoption[index + 1] = { value: item.id, label: item.title };
  // });

  const hosteloptions = hostelIDs.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const defaultHotOpt = {
    value: defaulthol?.id || "",
    label: defaulthol?.name || "Select",
  };

  const vehicleoption = vehicleIDs.map((item) => ({
    value: item.id,
    label: item.model,
  }));
  const defaultVehOpt = {
    value: defaultVel?.id || "",
    label: defaultVel?.model || "Select",
  };

  const schooloptions = previousSchoolData.map((item) => ({
    value: item.id,
    label: item.name,
  }));
  const defaultSchoolOpt = {
    value: defaultSchool?.id || "",
    label: defaultSchool?.name || "Select",
  };

  const shiftoption = [
    { value: "1st", label: "1st" },
    { value: "2nd", label: "2nd" },
  ];

  const empOptions = [];
  empOptions[0] = { value: "", label: "Select..." };
  inServiceEmpList.map((item, index) => {
    empOptions[index + 1] = {
      value: item.id,
      label: `${
        item.full_name.length > 15
          ? item.full_name.substr(0, 10)
          : item.full_name
      }-${item.emp_code}`,
    };
  });

  const onChangeGetEmployeList = (event) => {
    setselectedEmpId(event.value);
  };
  const deleteFee = () => {
    setdeleteloading(true);

    fetch(`${baseUrl}/student_liable_fee/${deleteablefee.id}}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.show(data.payload);
            getDefinedFees();
            setdeleteloading(false);
            setdeleteModal(false);
            getfeeTypes(studentDetail.year_setting_id, allDefinedFees);
          } else {
            // alert.show(data.payload);
            setdeleteloading(false);
            setdeleteModal(false);
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
        setdeleteloading(false);
        setdeleteModal(false);
      });
  };
  const getDefinedFees = () => {
    fetch(`${baseUrl}/student_all_liable_fees/${studentDetail.id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            getfeeTypes(studentDetail.year_setting_id, data.payload);
            setallDefinedFees([...data.payload]);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //hitting concession apis
  const getConcessionTypes = () => {
    fetch(`${baseUrl}/concession`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            setallconcessions(data.payload);
            applyonMount(data.payload);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const applyonMount = (arr) => {
    const result = arr.filter((item) => item.id == studentDetail.concession_id);
    if (selectedConcType == "Percentage") {
      setallowedconcession(result[0].percentage);
    }
    if (selectedConcType == "Amount") {
      setallowedconcession(result[0].amount);
    }
  };
  const getRespctiveFee = (id) => {
    setselectedfeetype(id);
    let data = {
      campus_id: studentDetail.campus_id,
      course_id: studentDetail.course_id,
      student_class_id: studentDetail.student_class_id,
      fee_type_id: id,
      year_id: studentDetail.year_setting_id,
      concession: studentDetail.concession,
      payment_type_id: studentDetail.payment_type_id,
    };
    fetch(`${baseUrl}/fee-structure-amount`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            setonChangeAmount(data.payload.amount);
            setonChangeNetAmount(data.payload.net_amount);
            setamount(data.payload.amount);
          }
        }
      })
      .catch((err) => {
        alert.show("Something Went Wrong");
        console.log("err", err);
      });
  };

  const onChangeFeeAmount = (value) => {
    setconcessionamount(amount - value);
    setonChangeAmount(value);
    if (amount - value < 0) {
      setisallfields(true);
      seterrorcreate("Please Check Concession");
      return;
    } else {
      setisallfields(false);
      seterrorcreate("");
    }
    if (parseInt(value) < 0) {
      setisallfields(true);
      seterrorcreate("Please Check Amount");
      return;
    } else {
      setisallfields(false);
      seterrorcreate("");
    }
  };

  const getfeeTypes = (year_setting_id, arr2) => {
    fetch(
      `${baseUrl}/classfeetypes/${studentDetail.campus_id}/${studentDetail.course_id}/${studentDetail.student_class_id}/${year_setting_id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        let checkboxes = data.payload;
        data.payload.map((item, index) => {
          item["disabled"] = false;
          checkboxes[index] = item;
        });
        handleFeeTypeDisable(checkboxes, arr2);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleFeeTypeDisable = (arr, arr2) => {
    let array = [...arr];
    let array2 = [...arr2];
    let newArray = [];

    arr2.forEach((element, index) => {
      arr.forEach((item, i) => {
        if (element.fees_type_id == item.id) {
          arr[i].disabled = true;
        }
      });
    });
    setfeetypes(arr);
  };

  const feeDefine = () => {
    setisallfields(false);

    let res = checkerror();
    if (!res) {
      return;
    }

    setloading(true);
    let data = {
      student_id: studentDetail.id,
      fees_type_id: selectedfeetype,
      amount: onChangeAmount,
      concession:
        onChangeNetAmount > 0 ? onChangeNetAmount - onChangeAmount : 0,
      remarks: remarks,
    };

    fetch(`${baseUrl}/student_liable_fee`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setloading(false);
        setapplyconcessionbtn(true);
        setisallowedconcesstion(true);
        setallowedconcession(0);
        if (data.metadata) {
          if (data.metadata.success) {
            setloading(false);
            // show(false)
            alert.success("Fee Added success");
            setonChangeAmount("");
            setonChangeNetAmount("");
            setconcessionamount(0);
            getDefinedFees();
          } else {
            setloading(false);
            // show(false)
            alert.error("Fee Not Added");
          }
        } else {
          alert.error("Fee Not Added");
        }
      })
      .catch((err) => {
        setloading(false);
        console.log("err", err);
        alert.show("Error Occured");
      });
  };
  const checkerror = () => {
    if (!selectedfeetype) {
      setisallfields(true);
      seterrorcreate("Please Add Amount");
      return false;
    }
    if (onChangeAmount == "") {
      setisallfields(true);
      seterrorcreate("Please Add Fee");
      return false;
    }
    setisallfields(false);
    return true;
  };

  return (
    <div>
      <Toaster />

      {loading ? (
        <b>
          Student Updating Please wait <span className="spinner-border"></span>
        </b>
      ) : (
        <div className="container-fluid">
          <div
            style={{
              marginTop: "0px",
              border: "0px",
              marginBottom: "0px",
              paddingBottom: "0px",
            }}
            className="card card-custom"
          >
            <div>
              <div className="row">
                <div className="col-12">
                  <div
                    className="login-form login-signin"
                    style={{ display: "block" }}
                  >
                    <Formik
                      enableReinitialize={true}
                      initialValues={initialValues}
                      validationSchema={StudentRegistrationSchema}
                      onSubmit={(values) => {
                        AddStudentHandler(values);
                      }}
                    >
                      {(props) => {
                        const {
                          handleSubmit,
                          errors,
                          touched,
                          values,
                          isSubmitting,
                          isValid,
                          handleChange,
                          handleBlur,
                        } = props;

                        setErrorsLis(errors);
                        createEroors(errors, touched, isSubmitting, values);

                        return (
                          <>
                            <div className="overlay overlay-block cursor-default">
                              <Form
                                onSubmit={handleSubmit}
                                className="form form-label-right"
                              >
                                <div className="row">
                                  <div className="col-lg-4">
                                    <label>
                                      Name{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Field
                                      disabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.name"
                                        )
                                      }
                                      name="name"
                                      component={Input}
                                      placeholder="First Name"
                                      maxLength={120}
                                      value={values.name}
                                      onChange={handleChange} // Ensure Formik handles changes
                                    />
                                  </div>
                                  <div className="col-lg-4">
                                    <label>
                                      Father Name{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Field
                                      disabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.father_name"
                                        )
                                      }
                                      name="father_name"
                                      component={Input}
                                      placeholder="Enter Father Name"
                                      maxLength={120}
                                      value={values.father_name} // Ensure Formik manages the value
                                      onChange={handleChange} // Ensure Formik handles changes
                                    />
                                  </div>

                                  <div className="col-lg-4">
                                    <label>
                                      Select Session{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <select
                                      disabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.session_selection"
                                        )
                                      }
                                      className="form-select form-control"
                                      name="year_id"
                                      value={values.year_id}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      style={{ backgroundColor: "white" }}
                                      aria-label="Default select example"
                                    >
                                      <option value="">Select Session</option>
                                      {allsessions.map((item, index) => (
                                        <option key={index} value={item.id}>
                                          {item.year}
                                        </option>
                                      ))}
                                    </select>
                                    {errors.year_id && touched.year_id && (
                                      <div
                                        style={{ color: "#f87d8a" }}
                                        className="input-feedback"
                                      >
                                        {errors.year_id}
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="form-group row">
                                  <div className="col-lg-4">
                                    <label>
                                      Campus{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <select
                                      disabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.select_campus"
                                        )
                                      }
                                      className="form-select form-control"
                                      name="campus_id"
                                      value={values.campus_id}
                                      onChange={(e) => {
                                        handleChange(e); // Call the handleChange from Formik
                                        onCampusChange(e.target.value); // Call the handleChange)
                                      }}
                                      onBlur={handleBlur}
                                      style={{ backgroundColor: "white" }}
                                      aria-label="Default select example"
                                    >
                                      <option value="">Select Campus</option>
                                      {campuses.map((item, index) => (
                                        <option key={index} value={item.id}>
                                          {item.name}
                                        </option>
                                      ))}
                                    </select>
                                    {errors.campus_id && touched.campus_id && (
                                      <div
                                        style={{ color: "#f87d8a" }}
                                        className="input-feedback"
                                      >
                                        {errors.campus_id}
                                      </div>
                                    )}
                                  </div>

                                  <div className="col-lg-4">
                                    <label>
                                      Course{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>

                                    <select
                                      disabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.select_course"
                                        )
                                      }
                                      className="form-select form-control"
                                      name="course_id"
                                      value={values.course_id}
                                      onChange={(e) => {
                                        handleChange(e); // Call the handleChange from Formik
                                        onCourseChange(e.target.value); // Call the handleChange)
                                      }}
                                      // onChange={handleChange}
                                      onBlur={handleBlur}
                                      style={{ backgroundColor: "white" }}
                                      aria-label="Default select example"
                                    >
                                      <option value="">Select Course</option>
                                      {campusCourseData.map((item, index) => (
                                        <option
                                          key={index}
                                          value={item.course?.id}
                                        >
                                          {item.course?.name}
                                        </option>
                                      ))}
                                    </select>
                                    {errors.course_id && touched.course_id && (
                                      <div
                                        style={{ color: "#f87d8a" }}
                                        className="input-feedback"
                                      >
                                        {errors.course_id}
                                      </div>
                                    )}
                                  </div>

                                  <div className="col-lg-4">
                                    <label>
                                      Class{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>

                                    <select
                                      disabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.select_class"
                                        )
                                      }
                                      className="form-select form-control"
                                      name="class_id"
                                      value={values.class_id}
                                      onChange={(e) => {
                                        handleChange(e); // Call the handleChange from Formik
                                        onClassChange(e.target.value); // Call the handleChange)
                                      }}
                                      // onChange={handleChange}
                                      onBlur={handleBlur}
                                      style={{ backgroundColor: "white" }}
                                      aria-label="Default select example"
                                    >
                                      <option value="">Select Class</option>
                                      {courseClassData.map((item, index) => (
                                        <option
                                          key={index}
                                          value={item.class?.id}
                                        >
                                          {item.class?.name}
                                        </option>
                                      ))}
                                    </select>
                                    {errors.class_id && touched.class_id && (
                                      <div
                                        style={{ color: "#f87d8a" }}
                                        className="input-feedback"
                                      >
                                        {errors.class_id}
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="form-group row">
                                  <div className="col-lg-4">
                                    <label>
                                      Section{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <select
                                      disabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.select_section"
                                        )
                                      }
                                      className="form-select form-control"
                                      name="section_id"
                                      value={values.section_id}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      style={{ backgroundColor: "white" }}
                                      aria-label="Default select example"
                                    >
                                      <option value="">Select Section</option>
                                      {classSectionData.map((item, index) => (
                                        <option
                                          key={index}
                                          value={item.section?.id}
                                        >
                                          {item.section?.name}
                                        </option>
                                      ))}
                                    </select>
                                    {errors.section_id && touched.section_id && (
                                      <div
                                        style={{ color: "#f87d8a" }}
                                        className="input-feedback"
                                      >
                                        {errors.section_id}
                                      </div>
                                    )}
                                  </div>

                                  <div className="col-lg-4">
                                    <label>Date of Birth </label>
                                    <Field
                                      disabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.dob"
                                        )
                                      }
                                      name="dob"
                                      component={Input}
                                      type="date"
                                      max="9999-11-30"
                                      value={values.dob} // Ensure Formik manages the value
                                      onChange={handleChange} // Ensure Formik handles changes
                                    />
                                  </div>

                                  <div className="col-lg-4">
                                    <label>
                                      Gender{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <select
                                      disabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.gender"
                                        )
                                      }
                                      className="form-select form-control"
                                      name="gender"
                                      value={values.gender}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      style={{ backgroundColor: "white" }}
                                      aria-label="Default select example"
                                    >
                                      <option value="">Select Gender</option>
                                      <option value="Male">Male</option>
                                      <option value="Female">Female</option>
                                      <option value="Other">Other</option>
                                    </select>
                                    {errors.gender && touched.gender && (
                                      <div
                                        style={{ color: "#f87d8a" }}
                                        className="input-feedback"
                                      >
                                        {errors.gender}
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="form-group row">
                                  <div className="col-lg-4">
                                    <label>Concession </label>
                                    <Select
                                      isDisabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.concession_selection"
                                        )
                                      }
                                      defaultValue={defaultConcession}
                                      className="input"
                                      onChange={(e) => {
                                        setanyconcesstion(e.value);
                                        if (e.value == "2") {
                                          setempEnable(true);
                                        } else {
                                          setempEnable(false);
                                        }
                                      }}
                                      placeholder="Select Concession"
                                      options={[
                                        { value: "", label: "Select" },
                                        ...concessionOptions,
                                      ]}
                                    />
                                  </div>

                                  <div className="col-lg-4">
                                    <label>Enter Concession Remarks </label>
                                    <Field
                                      disabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.concession_remarks"
                                        ) || !(anyconcesstion != "")
                                      }
                                      name="concesstion_remarks"
                                      component={Input}
                                      placeholder="Concesstion Remarks"
                                      type="text"
                                      required
                                      value={values.concesstion_remarks} // Ensure Formik manages the value
                                      onChange={handleChange} // Ensure Formik handles changes
                                    />
                                  </div>

                                  <div className="col-lg-4">
                                    <label>Concession Slab (%) </label>

                                    <Field
                                      disabled={!(anyconcesstion != "")}
                                      name="concession"
                                      component={Input}
                                      placeholder="1-100 %"
                                      type="number"
                                      required
                                      value={values.concession} // Ensure Formik manages the value
                                      onChange={(e) => {
                                        handleChange(e);
                                        setConcessionSlab(e.target.value);
                                      }} // Ensure Formik handles changes
                                    />
                                  </div>

                                  <div className="col-lg-4">
                                    <label>Payment Type </label>{" "}
                                    <span style={{ color: "red" }}>*</span>
                                    <select
                                      className="form-select form-control"
                                      name="payment_type_id"
                                      value={values.payment_type_id}
                                      onChange={(e) => {
                                        handleChange(e);
                                        setAnyPaymentType(e.target.value);
                                      }}
                                      onBlur={handleBlur}
                                      style={{ backgroundColor: "white" }}
                                      aria-label="Default select example"
                                    >
                                      <option value="">
                                        Select Payment Type
                                      </option>
                                      {paymentType.map((item, index) => (
                                        <option key={index} value={item.id}>
                                          {item.name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>

                                  <div className="col-lg-4">
                                    <label>Select Employee </label>
                                    <div className="input">
                                      <CustomSelect
                                        disabled={
                                          !PremissionChecker(
                                            user,
                                            "edit_student.select_employee"
                                          ) || empEnable
                                            ? false
                                            : true
                                        }
                                        // isDisabled={empEnable ? false : true}
                                        className="input"
                                        value={selectedEmpId}
                                        onChange={(evt) => {
                                          onChangeGetEmployeList(evt);
                                        }}
                                        placeholder="Select Employee"
                                        options={empOptions}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-lg-4">
                                    <label>
                                      Address{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>

                                    <Field
                                      disabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.address"
                                        )
                                      }
                                      name="address"
                                      maxLength={120}
                                      component={Input}
                                      placeholder="Enter Your Address"
                                      value={values.address} // Ensure Formik manages the value
                                      onChange={handleChange} // Ensure Formik handles changes
                                    />
                                  </div>

                                  <div className="col-lg-4">
                                    <label>Religion </label>
                                    <Field
                                      disabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.religion"
                                        )
                                      }
                                      name="religion"
                                      component={Input}
                                      placeholder="Enter Your Religion"
                                      maxLength={120}
                                      value={values.religion} // Ensure Formik manages the value
                                      onChange={handleChange} // Ensure Formik handles changes
                                    />
                                  </div>

                                  <div className="col-lg-4">
                                    <label>Hostel </label>

                                    <Select
                                      isDisabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.select_hostel"
                                        )
                                      }
                                      defaultValue={defaultHotOpt}
                                      className="input"
                                      onChange={(e) => setanyhostel(e.value)}
                                      placeholder="Select Hostel"
                                      options={[
                                        { value: "", label: "Select" },
                                        ...hosteloptions,
                                      ]}
                                    />
                                  </div>

                                  <div className="col-lg-4">
                                    <label>Vehicle </label>

                                    <Select
                                      isDisabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.select_vehicle"
                                        )
                                      }
                                      defaultValue={defaultVehOpt}
                                      className="input"
                                      onChange={(e) => setanyvehicle(e.value)}
                                      placeholder="Select Vehicle"
                                      options={[
                                        { value: "", label: "Select" },
                                        ...vehicleoption,
                                      ]}
                                    />
                                  </div>

                                  <div className="col-lg-4">
                                    <label>Father CNIC </label>
                                    <Field
                                      name="father_cnic"
                                      render={({ field }) => (
                                        <MaskedInput
                                          {...field}
                                          disabled={
                                            !PremissionChecker(
                                              user,
                                              "edit_student.father_cnic"
                                            )
                                          }
                                          mask={cnicNumberMask}
                                          id="father_cnic"
                                          placeholder="Enter Your Father CNIC"
                                          type="text"
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          // className='is-invalid form-control'
                                          className={
                                            errors.father_cnic &&
                                            touched.father_cnic
                                              ? "is-invalid form-control"
                                              : "form-control"
                                          }
                                        />
                                      )}
                                    />
                                  </div>

                                  <div className="col-lg-4">
                                    <label>CNIC/B-Form </label>

                                    <Field
                                      name="cnic_no"
                                      render={({ field }) => (
                                        <MaskedInput
                                          {...field}
                                          disabled={
                                            !PremissionChecker(
                                              user,
                                              "edit_student.student_cnic"
                                            )
                                          }
                                          mask={cnicNumberMask}
                                          id="cnic_no"
                                          placeholder="Enter Your CNIC / B-Form No"
                                          type="text"
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          className={
                                            errors.cnic_no && touched.cnic_no
                                              ? "is-invalid form-control"
                                              : "form-control"
                                          }
                                        />
                                      )}
                                    />
                                  </div>

                                  <div className="col-lg-4">
                                    <label>
                                      Remarks{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>

                                    <Field
                                      maxLength={120}
                                      name="remarks"
                                      value={values.remarks}
                                      component={Input}
                                      placeholder="remarks"
                                      onChange={handleChange} // Ensure Formik handles changes
                                    />
                                  </div>

                                  <div className="col-lg-4">
                                    <label>Shift </label>
                                    <select
                                      disabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.select_shift"
                                        )
                                      }
                                      className={"form-select form-control"}
                                      name="shift"
                                      value={values.shift}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      aria-label="Default select example"
                                    >
                                      {shiftoption.map((item, index) => (
                                        <option key={index} value={item.value}>
                                          {item.label}
                                        </option>
                                      ))}
                                    </select>
                                    {errors.shift && touched.shift && (
                                      <div
                                        style={{ color: "#f87d8a" }}
                                        className="input-feedback"
                                      >
                                        {errors.shift}
                                      </div>
                                    )}
                                  </div>

                                  <div className="col-lg-4">
                                    <label>Previous School</label>

                                    <Select
                                      isDisabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.previous_school"
                                        )
                                      }
                                      className="input"
                                      defaultValue={defaultSchoolOpt}
                                      onChange={(evt) => {
                                        setPrevSchool(evt.value);
                                      }}
                                      placeholder="Select School"
                                      options={[
                                        { value: "", label: "Select" },
                                        ...schooloptions,
                                      ]}
                                    />
                                  </div>
                                  <div className="col-lg-4">
                                    <label>
                                      Class Left{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>

                                    <Field
                                      disabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.class_left"
                                        )
                                      }
                                      maxLength={120}
                                      name="class_left"
                                      component={Input}
                                      placeholder="Enter Student Class left"
                                      value={values.class_left} // Ensure Formik manages the value
                                      onChange={handleChange} // Ensure Formik handles changes
                                    />
                                  </div>

                                  <div className="col-lg-4">
                                    <label>Leaving Date </label>

                                    <Field
                                      disabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.leaving_date"
                                        )
                                      }
                                      name="leaving_date"
                                      component={Input}
                                      type="date"
                                      max="9999-11-30"
                                      value={values.leaving_date} // Ensure Formik manages the value
                                      onChange={handleChange} // Ensure Formik handles changes
                                    />
                                  </div>

                                  <div className="col-lg-4">
                                    <label>Student Status</label>
                                    <select
                                      disabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.student_status"
                                        )
                                      }
                                      className={"form-select form-control"}
                                      value={studentStatus}
                                      onChange={(e) => {
                                        let value = e.target.value;
                                        if (
                                          value == 4 ||
                                          value == 5 ||
                                          value == 6 ||
                                          value == 7
                                        ) {
                                          setShowStuckDate(true);
                                        } else {
                                          setShowStuckDate(false);
                                        }
                                        setstudentStatus(e.target.value);
                                      }}
                                      aria-label="Default select example"
                                    >
                                      <option value="">Select Status</option>
                                      {studentStatusData.map((item, index) => (
                                        <option key={index} value={item.id}>
                                          {item.name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>

                                  <div className="col-md-4">
                                    <label>Joining date</label>
                                    <Field
                                      disabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.joining_date"
                                        )
                                      }
                                      name="joining_date"
                                      component={Input}
                                      type="date"
                                      max="9999-11-30"
                                    />
                                  </div>

                                  {showStuckDate ? (
                                    <div className="col-md-4">
                                      <label>Stuck Of Date</label>
                                      <Field
                                        disabled={
                                          !PremissionChecker(
                                            user,
                                            "edit_student.stuck_of_date"
                                          )
                                        }
                                        name="stuck_date"
                                        component={Input}
                                        type="date"
                                        max="9999-11-30"
                                      />
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>

                                <div className="form-group row">
                                  <div className="col-lg-6">
                                    <label>
                                      Mobile Number{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>

                                    <Field
                                      disabled={
                                        !PremissionChecker(
                                          user,
                                          "edit_student.mobile_number"
                                        )
                                      }
                                      maxLength={20}
                                      pattern="^(\+92)(3)([0-9]{9})$"
                                      required
                                      name="mobile_no"
                                      component={Input}
                                      placeholder="Enter Your Smart Phone Number"
                                      value={values.mobile_no} // Ensure Formik manages the value
                                      onChange={handleChange} // Ensure Formik handles changes
                                    />
                                  </div>

                                  <div className="col-lg-6">
                                    <label>Landline Number </label>
                                    <Field
                                      maxLength={20}
                                      pattern="^(?!92)\d+"
                                      required
                                      name="phone"
                                      component={Input}
                                      placeholder="Enter Your Phone/LandLine No"
                                    />
                                  </div>
                                </div>
                              </Form>
                            </div>

                            <div>
                              {/* /////this is for define fee section */}
                              <div className="">
                                <div className="row d-flex justify-content-center ">
                                  <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                                    <div>
                                      {PremissionChecker(
                                        user,
                                        "edit_student.all_defined_fees"
                                      ) ? (
                                        <div className="row justify-content-between text-left">
                                          <Table responsive>
                                            <thead>
                                              <tr id="tbl">
                                                <th>Fee Name</th>
                                                <th>Total Amount</th>
                                                <th>Payable Amount</th>
                                                <th>Concession</th>
                                                <th>Remarks</th>
                                                <th>Edit</th>
                                                <th>Delete</th>
                                                <th>Update</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {allDefinedFees.map((fees, i) => {
                                                return (
                                                  <tr
                                                    key={fees.id}
                                                    className="addstudentList"
                                                  >
                                                    <td>
                                                      {fees?.fee_type?.name}
                                                    </td>
                                                    <td>
                                                      {parseInt(fees.amount) +
                                                        parseInt(
                                                          fees.concession
                                                        )}
                                                    </td>
                                                    <td>{fees.amount}</td>
                                                    <td>{fees.concession}</td>
                                                    {/* <td  >remark?</td> */}
                                                    <td>
                                                      {fees?.remarks?.length >
                                                      35
                                                        ? fees?.remarks.slice(
                                                            0,
                                                            35
                                                          ) + ".."
                                                        : fees?.remarks}
                                                    </td>
                                                    <td>
                                                      {PremissionChecker(
                                                        user,
                                                        "edit_student.edit_define_fee"
                                                      ) ? (
                                                        <a
                                                          className={
                                                            PremissionChecker(
                                                              user,
                                                              "edit_student.edit_define_fee"
                                                            )
                                                              ? "btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                                                              : "btn btn-icon btn-light btn-hover-primary btn-sm mx-3 disabledSvg"
                                                          }
                                                          onClick={() => {
                                                            seteditablefee(
                                                              fees
                                                            );
                                                            seteditmodal(true);
                                                          }}
                                                        >
                                                          <span className="svg-icon svg-icon-md svg-icon-primary ">
                                                            <SVG
                                                              src={toAbsoluteUrl(
                                                                "/media/svg/icons/Communication/Write.svg"
                                                              )}
                                                            />
                                                          </span>
                                                        </a>
                                                      ) : null}
                                                    </td>
                                                    <td>
                                                      {PremissionChecker(
                                                        user,
                                                        "edit_student.delete_define_fee"
                                                      ) ? (
                                                        <a
                                                          onClick={() => {
                                                            setdeleteablefee(
                                                              fees
                                                            );
                                                            setdeleteModal(
                                                              true
                                                            );
                                                          }}
                                                        >
                                                          <span className="svg-icon svg-icon-md svg-icon-danger">
                                                            <SVG
                                                              src={toAbsoluteUrl(
                                                                "/media/svg/icons/Communication/Delete-user.svg"
                                                              )}
                                                            />
                                                          </span>
                                                        </a>
                                                      ) : null}
                                                    </td>

                                                    <td>
                                                      {PremissionChecker(
                                                        user,
                                                        "edit_student.update_define_fee"
                                                      ) ? (
                                                        <a
                                                          className={
                                                            PremissionChecker(
                                                              user,
                                                              "edit_student.update_define_fee"
                                                            )
                                                              ? "btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                                                              : "btn btn-icon btn-light btn-hover-primary btn-sm mx-3 disabledSvg"
                                                          }
                                                          onClick={() => {
                                                            updateStudentLiableFees();
                                                            // setdeleteablefee(fees);
                                                          }}
                                                        >
                                                          <span className="svg-icon svg-icon-md svg-icon-success">
                                                            <SVG
                                                              src={toAbsoluteUrl(
                                                                "/media/svg/icons/Files/Download.svg"
                                                              )}
                                                            />
                                                          </span>
                                                        </a>
                                                      ) : null}
                                                    </td>
                                                  </tr>
                                                );
                                              })}
                                            </tbody>
                                          </Table>
                                        </div>
                                      ) : (
                                        <Empty
                                          description={
                                            "You dont have Permission to view Fee defined list"
                                          }
                                        ></Empty>
                                      )}
                                      <div className="row justify-content-between text-left mt-5">
                                        <>
                                          {PremissionChecker(
                                            user,
                                            "edit_student.can_add_fee"
                                          ) ? (
                                            <>
                                              <div className="form-group col-sm-4 flex-column d-flex">
                                                <label className="form-control-label">
                                                  <b>
                                                    Fee Type{" "}
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>{" "}
                                                  </b>
                                                </label>
                                                <select
                                                  disabled={
                                                    !PremissionChecker(
                                                      user,
                                                      "edit_student.fee_type"
                                                    )
                                                  }
                                                  id="feeselect"
                                                  // value={designation_id}
                                                  onChange={(e) => {
                                                    setapplyconcessionbtn(true);
                                                    setonChangeAmount("");
                                                    setonChangeNetAmount("");
                                                    setconcessionamount(0);
                                                    getRespctiveFee(
                                                      e.target.value
                                                    );
                                                    if (
                                                      allowedconcession == 0
                                                    ) {
                                                      setisallowedconcesstion(
                                                        true
                                                      );
                                                    } else {
                                                      setisallowedconcesstion(
                                                        false
                                                      );
                                                    }
                                                    // checkerror()
                                                  }}
                                                  className="form-select form-control"
                                                  aria-label="Default select example"
                                                  style={{ height: "40px" }}
                                                >
                                                  <option disabled value="">
                                                    Select Fee Type{" "}
                                                  </option>
                                                  {feetypes.map(
                                                    (feetype, index) => (
                                                      <option
                                                        disabled={
                                                          feetype.disabled
                                                        }
                                                        key={feetype.id}
                                                        value={feetype.id}
                                                      >
                                                        {feetype.name}
                                                      </option>
                                                    )
                                                  )}
                                                </select>
                                              </div>

                                              <div className="form-group col-sm-4 flex-column d-flex">
                                                <label className="form-control-label">
                                                  <b>
                                                    Amount{" "}
                                                    <span
                                                      style={{ color: "red" }}
                                                    >
                                                      *
                                                    </span>
                                                  </b>
                                                </label>
                                                <input
                                                  disabled={
                                                    !PremissionChecker(
                                                      user,
                                                      "edit_student.fee_amount"
                                                    )
                                                  }
                                                  className="form-control"
                                                  value={onChangeAmount}
                                                  onChange={(e) => {
                                                    if (e.target.value == "") {
                                                      setisallfields(true);
                                                      seterrorcreate(
                                                        "Please Add Fee"
                                                      );
                                                    } else {
                                                      setisallfields(false);
                                                    }

                                                    if (
                                                      parseInt(e.target.value) <
                                                      0
                                                    ) {
                                                      setisallfields(true);
                                                      seterrorcreate(
                                                        "Please Enter Correct amount"
                                                      );
                                                    } else {
                                                      setisallfields(false);
                                                      seterrorcreate("");
                                                    }
                                                    onChangeFeeAmount(
                                                      e.target.value
                                                    );
                                                  }}
                                                  type="number"
                                                  placeholder="Enter Fee Amount"
                                                />
                                              </div>

                                              <div className="form-group col-sm-4 flex-column d-flex">
                                                <label className="form-control-label">
                                                  <b>Remarks </b>
                                                </label>
                                                <input
                                                  className="form-control"
                                                  placeholder="Enter Fee Remarks"
                                                  onChange={(e) => {
                                                    setremarks(e.target.value);
                                                  }}
                                                  type="text"
                                                />
                                              </div>
                                            </>
                                          ) : null}
                                        </>
                                      </div>
                                      {isallfields ? (
                                        <>
                                          <Alert
                                            variant="danger"
                                            onClose={() =>
                                              setisallfields(false)
                                            }
                                            dismissible
                                          >
                                            <Alert.Heading>
                                              Oh snap! You got an error!
                                            </Alert.Heading>
                                            <p>{errorcreate}</p>
                                          </Alert>
                                        </>
                                      ) : null}
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                        className="btns"
                                      ></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* /////define fee end section */}

                            <div
                              className="mt-5"
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              {PremissionChecker(
                                user,
                                "edit_student.can_add_fee"
                              ) ? (
                                <button
                                  disabled={
                                    parseInt(concessionamount) < 0
                                      ? true
                                      : parseInt(onChangeAmount) < 0
                                      ? true
                                      : false
                                  }
                                  // type="button"
                                  onClick={feeDefine}
                                  className="btn btn-success button_blue pl-4 pr-4"
                                >
                                  Add Fee
                                </button>
                              ) : (
                                <small>Permission Denied</small>
                              )}

                              <button
                                type="submit"
                                style={{ marginLeft: "15px" }}
                                className="btn btn-success button_blue btn-elevate"
                                onClick={() => handleSubmit()}
                              >
                                <span> Save </span>
                                {loading && (
                                  <span className="ml-3 spinner spinner-white"></span>
                                )}
                              </button>

                              <button
                                style={{ marginLeft: "15px" }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  show(false);
                                }}
                                className="btn btn-danger btn_width btn-elevate"
                              >
                                Cancel
                              </button>

                              <> </>
                            </div>
                          </>
                        );
                      }}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <EditDefinedFee
        feeDetail={editablefee}
        onHide={seteditmodal}
        show={editmodal}
        getDefinedFees={getDefinedFees}
      />

      <Modal show={deleteModal}>
        <Modal.Header className="modal_header_style" closeButton>
          <Modal.Title
            className="Modal_Heading_font"
            id="contained-modal-title-vcenter"
          >
            Are you want to delete
          </Modal.Title>
        </Modal.Header>
        {deleteloading ? (
          <div style={{ padding: "20px" }}>
            {" "}
            <b style={{ color: "green" }}>
              {" "}
              Fee Deleting Please Wait <span className="spinner-borderd"></span>
            </b>
          </div>
        ) : (
          <Modal.Footer>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button onClick={deleteFee} className="btn button_blue">
                Delete
              </button>
              <button
                style={{ marginLeft: "10px" }}
                onClick={() => setdeleteModal(false)}
                className="btn btn-danger btn_width"
              >
                Cancel
              </button>
            </div>
          </Modal.Footer>
        )}
      </Modal>
    </div>
  );
};

export default EditStudent;
